module.exports = __webpack_public_path__ + "img/30.02f04e73.png";